import { storeToRefs } from 'pinia';
import { DateTime } from 'luxon';

const lang = ref('en');

export default function () {
    const store = usePupilStore();
    store.fetchPupil().catch(() => {});
    const { pupil } = storeToRefs(store);

    watch(
        pupil,
        () => {
            let newLang = 'en';
            if (pupil.value) {
                newLang = pupil.value.ui_language;
            }
            if (newLang !== lang.value) {
                lang.value = newLang;
            }
        },
        { immediate: true },
    );

    const translations = useTranslations(lang);

    const getSplit = (key: string, n: number) => {
        const str = translations.get(key);
        return str.split('%s')[n];
    };

    const formatDateWithWeekday = (date: string | DateTime) => {
        const datetime = typeof date === 'string' ? DateTime.fromISO(date) : date;
        const wday = translations.get(datetime.weekdayShort || '');
        const day = datetime.day;
        const month = translations.get(datetime.monthShort || '');
        const year = datetime.year;
        return `${wday}, ${day} ${month} ${year}`;
    };

    return {
        get: translations.get,
        getSplit,
        language: lang,
        formatDateWithWeekday,
    };
}
